/**
 * @file Coord-search-errors.tsx
 * @module CoordSearchError
 * @description Peldoša kļūdas ziņojuma komponente nederīgai koordinātu meklēšanai.
 *              Tiek parādīta, kad lietotājs ievada koordinātas ārpus Latvijas
 *              robežām (EPSG:3857 apgabala pārbaude). Aizveras ar klikšķi.
 */

import { useEffect } from "react";

/**
 * Renders a coordinate input error message below the search bar.
 * Closes automatically when the user clicks outside the tooltip.
 *
 * @param hide - Callback to dismiss the error message
 */
export const CoordSearchError = ({ hide }: { hide: () => void }) => {
	useEffect(() => {
		addListener();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const addListener = () => {
		document.addEventListener("click", (e) => {
			if (!document.getElementById("coord-seach-error")?.contains(e.target as any)) {
				hide();
			}
		});
	};

	return (
		<span id="coord-seach-error">
			<div className="bg-white z-50 rounded-b p-4 absolute top-20 left-4 w-[29em]">
				Tika ievadītas nederīgas Koordinātas. <br />
				Pareizs formāts:
				<span className="font-semibold text-black/80"> (lat) (lon)</span>
				<br />
				Paraugs:
				<span className="font-semibold text-black/80">56.946285 24.105078</span>
			</div>
		</span>
	);
};
